import { KLAGE_VEDTAK } from "../actions/klager/vedtakAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const vedtakerReducer = (state = [...INITIAL_STATE], action) =>
  CreateNewReducer(state, action, KLAGE_VEDTAK);

export default vedtakerReducer;
